import VietMeetJS from '../../base/vietmeet-lib';
export * from './functions.any';
/**
 * Removes all analytics related options from the given configuration, in case of a libre build.
 *
 * @param {*} _config - The configuration which needs to be cleaned up.
 * @returns {void}
 */
export function _cleanupConfig(_config) {
    return;
}
/**
 * Returns the replaceParticipant config.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean}
 */
export function getReplaceParticipant(state) {
    return state['features/base/config'].replaceParticipant;
}
/**
 * Returns the configuration value of web-hid feature.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean} True if web-hid feature should be enabled, otherwise false.
 */
export function getWebHIDFeatureConfig(state) {
    return state['features/base/config'].enableWebHIDFeature || false;
}
/**
 * Returns whether audio level measurement is enabled or not.
 *
 * @param {Object} state - The state of the app.
 * @returns {boolean}
 */
export function areAudioLevelsEnabled(state) {
    return !state['features/base/config'].disableAudioLevels && VietMeetJS.isCollectingLocalStats();
}
/**
 * Sets the defaults for deeplinking.
 *
 * @param {IDeeplinkingConfig} deeplinking - The deeplinking config.
 * @returns {void}
 */
export function _setDeeplinkingDefaults(deeplinking) {
    deeplinking.desktop = deeplinking.desktop || {};
    deeplinking.android = deeplinking.android || {};
    deeplinking.ios = deeplinking.ios || {};
    const { android, desktop, ios } = deeplinking;
    desktop.appName = desktop.appName || 'VietMeet';
    desktop.appScheme = desktop.appScheme || 'vietmeet';
    desktop.download = desktop.download || {};
    desktop.download.windows = desktop.download.windows
        || 'https://vietmeet.example';
    desktop.download.macos = desktop.download.macos
        || 'https://vietmeet.example';
    desktop.download.linux = desktop.download.linux
        || 'https://vietmeet.example';
    ios.appName = ios.appName || 'VietMeet';
    ios.appScheme = ios.appScheme || 'com.vietmeet';
    ios.downloadLink = ios.downloadLink
        || 'https://vietmeet.example/ios';
    android.appName = android.appName || 'VietMeet';
    android.appScheme = android.appScheme || 'com.vietmeet';
    android.downloadLink = android.downloadLink
        || 'https://play.google.com/store/apps/details?id=com.vietmeet';
    android.appPackage = android.appPackage || 'com.vietmeet';
    android.fDroidUrl = android.fDroidUrl || 'https://f-droid.org/packages/com.vietmeet/';
}
